import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class SetPromoCodeRequest
*  Сохранение промокода корзины (§7.3).
*/
export class SetPromoCodeRequest extends ActiveModel {

/**
  * code
  * 
  */
  @ActiveField('')
  code: string = ''
}
